import type { VersionDeviation } from './types.js';

interface ParsedSemver {
  major: number;
  minor: number;
  patch: number;
}

function parseSemver(input: string): ParsedSemver | null {
  const match = input.trim().match(/^(\d+)\.(\d+)\.(\d+)(?:[-+].*)?$/);
  if (!match) {
    return null;
  }

  return {
    major: Number(match[1]),
    minor: Number(match[2]),
    patch: Number(match[3]),
  };
}

export function checkDeviation(
  backendVersion: string,
  frontEndVersion: string,
): VersionDeviation {
  const parsedBackend = parseSemver(backendVersion);
  const parsedFrontend = parseSemver(frontEndVersion);

  if (!parsedBackend || !parsedFrontend) {
    return {
      compatible: false,
      smallMismatch: false,
      breakingMismatch: true,
      backendVersion,
      frontEndVersion,
    };
  }

  if (parsedBackend.major !== parsedFrontend.major) {
    return {
      compatible: false,
      smallMismatch: false,
      breakingMismatch: true,
      backendVersion,
      frontEndVersion,
    };
  }

  if (parsedBackend.minor !== parsedFrontend.minor) {
    return {
      compatible: true,
      smallMismatch: true,
      breakingMismatch: false,
      backendVersion,
      frontEndVersion,
    };
  }

  return {
    compatible: true,
    smallMismatch: false,
    breakingMismatch: false,
    backendVersion,
    frontEndVersion,
  };
}
